import { render, staticRenderFns } from "./TroubleshootPage.vue?vue&type=template&id=63197a5d&scoped=true&"
import script from "./TroubleshootPage.vue?vue&type=script&lang=js&"
export * from "./TroubleshootPage.vue?vue&type=script&lang=js&"
import style0 from "./TroubleshootPage.vue?vue&type=style&index=0&id=63197a5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63197a5d",
  null
  
)

export default component.exports